import { SignedRequestResponse as SignedRequestResponseV0 } from '../../../../typings/api/skymap/rest/v0/.common';
import { SignedRequestResponse as SignedRequestResponseV1 } from '../../../../typings/api/skymap/rest/v1/.common';

export interface CloudFrontSignerParameters {
  baseUrl: string;
  signedRequest: string;
}

/**
 *  Handles signing CloudFront urls based on the parameters from a signed request call.
 */
export class CloudFrontSigner {
  constructor(private signerParameters: CloudFrontSignerParameters) {}

  getSignedRequest(
    filePath: string,
    options?: {
      noCache: number;
    },
  ) {
    let url = `${this.signerParameters.baseUrl}${filePath}?${this.signerParameters.signedRequest}`;

    // Append the noCache parameter if it is provided
    if (options?.noCache) {
      url += `&nocache=${options.noCache}`;
    }

    return url;
  }

  getBaseUrl() {
    return this.signerParameters.baseUrl;
  }
}

/**
 *  Converts a SignedRequestResponse from the backend to a client structure.
 * @param signedRequestResponse - The response from a signed request call.
 */
export const toCloudFrontSignerParameters = (
  signedRequestResponse: SignedRequestResponseV0 | SignedRequestResponseV1,
): CloudFrontSignerParameters => {
  return {
    baseUrl: signedRequestResponse.data.baseUrl,
    signedRequest: signedRequestResponse.data.signedRequest,
  };
};
